
import PreviewPairData from '@/components/block/PreviewPairData.vue'
import InlineFrame from '@/components/block/InlineFrame.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import TextBlock from '@/components/block/TextBlock.vue'
import HeadingLv4 from '@/components/elements/HeadingLv4.vue'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'
import Button from '@/components/elements/Button.vue'
import HrBlock from '@/components/elements/HrBlock.vue'
// import Alert from '@/components/elements/Alert.vue'
import TextLink from '@/components/elements/TextLink.vue'
import { onMounted, computed, SetupContext, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

export default {
  name: 'RegistConfirm',

  components: {
    PreviewPairData,
    GoalButtons,
    HeadingLv4,
    Button
  },

  props: {
    data: Object
  },

  setup(props: any, context: SetupContext) {
    const hiddenPassword = () => {
      let res = ''
      for (let i = 0; i < props.data.password.length; i++) {
        res += '●'
      }
      return res
    }

    const confirmContents = [
      {
        label: 'メールアドレス',
        content: props.data.email
      },
      {
        label: 'パスワード',
        content: hiddenPassword()
      }
    ]

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )

    const router = useRouter()
    const registerPassword = async () => {
      try {
        await axios.post('/api/v1/start_use/register_password', {
          email: props.data.email,
          password: props.data.password,
          password_confirmation: props.data.password_confirmation,
          csrf: csrf,
          token: props.data.token
        })
        router.push('/procedure/complete')
      } catch (error) {
        alert(
          '予期せぬエラーが発生しました。再度仮登録フォームから設定をお願いします。'
        )
        router.push('/procedure/register')
      }
    }

    return {
      confirmContents,
      csrf,
      registerPassword
    }
  }
}
